const isBoolean = (value: boolean | undefined) => typeof value === 'boolean';

export default isBoolean;
